<template>
  <div class="row">
    <div class="col">
      <div v-if="isRechercheDataLoading == true" class="row">
        <div class="col">
          <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
        </div>
      </div>
      <div v-else class="row">
        <DataTable
            class="p-datatable-sm"
            :value="dossiers"
            :resizableColumns="true"
            columnResizeMode="fit"
            :sortField="sortField"
            :sortOrder="sortOrder"
            @sort="onSort"
            :reorderableColumns="true"
            selectionMode="single"
            dataKey="cle"
            @row-select="onRowSelect"
            :paginator="true"
            :rows="100" 
            :rowClass="rowClass"
            paginatorPosition="both"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 30, 100]"
            currentPageReportTemplate="Afficher {first} à {last} sur {totalRecords} dossiers"
        >
          <template #empty>
            <div v-if="isRechercheDataLoading == true" class="row">
              <div class="col">
                <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
              </div>
            </div>
            <div v-else class="row">
              &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
            </div>
          </template>
          <Column
              field="numeroCardexAfficher"
              header="Numéro Cardex"
              :sortable="true"
          ></Column>
          <Column
              field="numeroDossier"
              header="No Dossier"
              :sortable="true"
          ></Column>
          <Column
              field="reference1"
              header="Réf. 1"
              :sortable="true"
          ></Column>
          <Column
              field="reference2"
              header="Réf. 2"
              :sortable="true"
          ></Column>
          <Column
              field="reference3"
              header="Réf. 3"
              :sortable="true"
          ></Column>
          <Column field="severiteAfficher" header="Sév." :sortable="true">
            <template #body="slotProps">
              <div v-bind:class="obtenirCouleur(slotProps.data.severite)">
                {{ slotProps.data.severiteAfficher }}
              </div>
            </template>
          </Column>
          <Column
              field="confidentialiteAfficher"
              header="Conf."
              :sortable="true"
          ></Column>
          <Column
              field="typeAfficher"
              header="Type"
              :sortable="true"
          ></Column>
          <Column
              field="categorieAfficher"
              header="Catégorie"
              :sortable="true"
          ></Column>
          <Column field="periodeAfficher"
                  header="Période"
                  :sortable="true">
          </Column>
          <Column
              field="statutAfficher"
              header="Statut"
              :sortable="true"
          ></Column>
          <Column
              field="fondeAfficher"
              header="Fondé"
              :sortable="true"
          ></Column>
          <Column field="debutDate" header="Date de début" :sortable="true">
            <template #body="slotProps">
              {{ $commun.formatDateHeure(slotProps.data.debutDate) }}
            </template>
          </Column>
          <Column field="finDate" header="Date de fin" :sortable="true">
            <template #body="slotProps">
              {{ $commun.formatDateHeure(slotProps.data.finDate) }}
            </template>
          </Column>
          <Column
              field="descriptif"
              header="Descriptif"
              :sortable="true"
          ></Column>
          <Column
              field="principaleIntervenant"
              header="Intervenant"
              :sortable="true"
          ></Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { ref } from 'vue';

export default {
  name: "ResultatDossier",
  props: ['dossiers', 'isRechercheDataLoading'],
  computed: {
    ...mapGetters({
      actionAccesDecision: 'dossier/actionAccesDecision',
      dossiersHistorique: 'dossier/dossiersHistorique',
    }),
  },
  setup() {
    const sortField = ref(localStorage.getItem('sortFieldDossier') || 'numeroCardexAfficher');
    const sortOrder = ref(Number(localStorage.getItem('sortOrderDossier')) || -1);
    const onSort = (event) => {
      sortField.value = event.sortField;
      sortOrder.value = event.sortOrder;
      localStorage.setItem('sortFieldDossier', event.sortField);
      localStorage.setItem('sortOrderDossier', event.sortOrder);
    };
    return {
      sortField,
      sortOrder,
      onSort
    };
  },
  methods: {
    onRowSelect(event) {
      if (this.actionAccesDecision.consulterActionDecision) {
        this.$store.commit('dossier/AJOUT_DOSSIER_HISTORIQUE', event.data.cle);
        this.$router.push({
          name: "dossierConsulter",
          params: {cle: event.data.cle, site: event.data.site,},
        });
      }
    },
    rowClass(data) {
      return this.dossiersHistorique.includes(data.cle) ? 'row-previously-selected' : null;
    },
    obtenirCouleur(cle) {
      return "severite" + cle;
    },
  },
};
</script>

<style scoped>
::v-deep(.row-previously-selected) {
    color: var(--row-previously-selected) !important;
}
</style>